/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tld_Pricing_Costs_DescriptionInputs */

const id_tld_pricing_costs_description = /** @type {(inputs: Tld_Pricing_Costs_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga beli dari registry dalam IDR. Kosongkan harga untuk aksi yang tidak tersedia pada masa itu.`)
};

const en_tld_pricing_costs_description = /** @type {(inputs: Tld_Pricing_Costs_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What the registry charges, in IDR. Leave a price empty when that action is not offered for the term.`)
};

/**
* | output |
* | --- |
* | "What the registry charges, in IDR. Leave a price empty when that action is not offered for the term." |
*
* @param {Tld_Pricing_Costs_DescriptionInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_costs_description = /** @type {((inputs?: Tld_Pricing_Costs_DescriptionInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Costs_DescriptionInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_costs_description(inputs)
	return id_tld_pricing_costs_description(inputs)
});